<template>
  <v-sheet
    color="primary"
    width="100%"
    height="100%"
    class="mx-auto pa-0 mt-n9"
    style="z-index: 1000; position: absolute"
    v-if="delayedLoading"
  >
    <v-row class="d-flex justify-center align-end mt-16" width="20px">
      <v-col cols="3" md="2" class="d-flex mx-auto mt-16 pb-1">
        <v-img src="@/assets/LogoVertical.png" contain width="20%" class="mx-auto pb-0 mt-16" />
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center mt-0 pt-0" v-if="delayedLoading">
      <v-col cols="3" md="2">
        <v-progress-linear class="mx-auto" color="primary3" indeterminate rounded height="6">
        </v-progress-linear>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: 'VOverlayIntro',
  props: ['loadingIntro'],
  data() {
    return {
      delayedLoading: true
    };
  },

  watch: {
    loadingIntro: {
      immediate: true,
      handler(val) {
        if (!val) {
          setTimeout(() => {
            this.delayedLoading = false;
          }, 2000);
        } else {
          this.delayedLoading = true;
        }
      }
    }
  }
};
</script>
